import { Group, Text } from "@mantine/core";
import type { JSX } from "react";
import { ListeningAnimation } from "@/common-ui";
import { useDetectedCuesStore } from "@/sales-tools/detected-cues/stores/DetectedCuesStore";
import { useSessionId } from "@/sdk";
import { getListeningText } from "./services/getListeningText";

export function Listening({ isInsightsEnabled }: { isInsightsEnabled: boolean }): JSX.Element | null {
    const sessionId = useSessionId();

    const cues = useDetectedCuesStore((state) => state.getDisplayCues(sessionId));

    return (
        <Group align="center" gap={4} wrap={"nowrap"}>
            <ListeningAnimation style={{ width: "1rem" }} />
            <Text size="0.75rem" c="dark.2">
                {getListeningText(cues, isInsightsEnabled)}
            </Text>
        </Group>
    );
}
